"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatsDiff = void 0;
class StatsDiff {
    numOfWorkers = 0;
    laborHours = 0;
    laborCost = 0;
    transportCost = 0;
    roleCounts = {};
    roleSectionCounts = {};
    orRoleCounts = {};
    offCounts = {};
    otLaborHours = 0;
    otLaborCost = 0;
    constructor() { }
}
exports.StatsDiff = StatsDiff;
